import axios from 'axios';
import { isPlainObject } from 'lodash';
import camelcaseKeys from 'camelcase-keys';

import { AxiosInstance } from 'axios';
import { API_BASE_URL } from './endpoints';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // @ts-ignore
  transformResponse: axios.defaults.transformResponse.concat(data => {
    return isPlainObject(data) ? camelcaseKeys(data, { deep: true }) : data;
  }),
});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/modules/api/axiosInstance.ts